module.exports = __webpack_public_path__ + "img/icon-prohibited_b.de11e0ed.svg";